import PropTypes from 'prop-types';

const HeroSection = ({
  backgroundImage,
  title,
  subtitle,
  buttons = [],
  textAlign = 'center',
  height = 'h-[50vh] md:h-[45vh] lg:h-[40vh]', // reduced height
}) => {
  return (
    <section
      className={`relative ${height} max-h-[70vh] overflow-hidden`} 
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt="Hero background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-20 w-full h-full flex items-center">
        <div className="container mx-auto px-4 md:px-8 pt-16 md:pt-20">
          <div
            className={`max-w-3xl ${
              textAlign === 'center' ? 'mx-auto text-center' : ''
            } ${textAlign === 'left' ? 'text-left' : ''} ${
              textAlign === 'right' ? 'text-right ml-auto' : ''
            }`}
          >
            <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-14">
              {title}
            </h1>

            {subtitle && (
              <p className="text-base md:text-lg text-white/90 mb-6 max-w-5xl mx-auto">
                {subtitle}
              </p>
            )}

            {buttons.length > 0 && (
              <div
                className={`flex flex-col sm:flex-row gap-4 ${
                  textAlign === 'center'
                    ? 'justify-center items-center'
                    : textAlign === 'right'
                    ? 'justify-end items-end'
                    : 'justify-start items-start'
                }`}
              >
                {buttons.map((button, index) => (
                  <button
                    key={index}
                    onClick={button.onClick}
                    className={`${button.className || 'btn-primary'} px-6 py-2 md:px-8 md:py-3 text-base font-semibold rounded-lg transition-all w-full sm:w-auto`}
                    style={button.style}
                  >
                    {button.icon && <span className="mr-1">{button.icon}</span>}
                    {button.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

HeroSection.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  buttons: PropTypes.array,
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  height: PropTypes.string,
};

export default HeroSection;
